import React from 'react';
import './chromecast_icon.scss';

export default function render() {
  let castButton;

  return (
    <div className="chromecast-icon">
      <button
        className="th-cast-icon"
        label="Cast"
        onClick={() => {
          if (castButton) {
            castButton.click();
          }
        }}
      />
      <div className="google-cast-button">
        <button
          is="google-cast-button"
          ref={(button) => { castButton = button; }}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/chromecast/icon/chromecast_icon.jsx